module.exports = __webpack_public_path__ + "img/call.f7fc06bb.svg";